// extracted by mini-css-extract-plugin
export default {"radio":"MGInputRadioButton_radio__UvEzo","input":"MGInputRadioButton_input__o3yns","visual":"MGInputRadioButton_visual__ijnO4","inner":"MGInputRadioButton_inner__TAmRO"};